
const randomResult = [['5', '6', '7', '5', '7', '9', '2', '7', '7', '9', '4', '9', '3', '4', '0', '2', '0', '0'], ['4', '0', '3', '0', '7', '0', '2', '7', '7', '7', '0', '2', '8', '9', '5', '8', '0', '0'], ['7', '9', '3', '3', '9', '0', '9', '9', '1', '8', '6', '4', '6', '3', '0', '4', '0', '0'], ['1', '7', '5', '7', '5', '9', '7', '1', '5', '5', '8', '4', '2', '0', '9', '3', '8', '0'], ['2', '4', '5', '1', '9', '6', '2', '8', '0', '1', '1', '9', '6', '8', '1', '7', '3', '0'], ['4', '1', '7', '3', '5', '0', '2', '8', '1', '4', '4', '8', '5', '9', '3', '3', '0', '0'], ['4', '1', '4', '8', '1', '8', '4', '8', '7', '7', '5', '2', '7', '9', '9', '1', '0', '0'], ['6', '2', '9', '7', '0', '0', '2', '1', '8', '0', '5', '9', '8', '2', '5', '5', '0', '0'], ['7', '7', '2', '1', '3', '2', '9', '0', '2', '0', '6', '8', '3', '8', '1', '0', '0', '0'], ['2', '9', '8', '7', '8', '6', '3', '7', '1', '2', '7', '2', '4', '8', '3', '1', '0', '0'], ['5', '2', '5', '2', '1', '8', '4', '5', '3', '1', '0', '8', '3', '9', '3', '7', '0', '0'], ['3', '1', '4', '4', '5', '0', '8', '7', '6', '9', '9', '5', '7', '2', '2', '1', '0', '0'], ['6', '7', '1', '3', '6', '6', '3', '3', '4', '4', '3', '3', '6', '4', '9', '5', '0', '0'], ['5', '7', '2', '1', '6', '2', '4', '0', '0', '7', '2', '2', '6', '9', '6', '5', '0', '0'], ['2', '4', '5', '3', '7', '3', '7', '3', '2', '9', '6', '7', '3', '3', '1', '5', '0', '0'], ['8', '2', '9', '9', '0', '2', '4', '6', '5', '5', '6', '8', '5', '0', '9', '6', '0', '0'], ['7', '9', '1', '3', '1', '0', '1', '7', '6', '5', '6', '7', '6', '6', '9', '3', '0'], ['4', '5', '6', '8', '0', '3', '6', '0', '7', '1', '5', '8', '9', '8', '0', '8', '0'], ['6', '2', '2', '4', '6', '0', '2', '2', '4', '8', '1', '2', '5', '5', '6', '7', '0', '0'], ['1', '0', '8', '0', '2', '3', '5', '0', '2', '9', '3', '5', '5', '3', '2', '0', '6', '0'], ['5', '8', '9', '7', '6', '8', '1', '9', '4', '6', '1', '4', '7', '1', '2', '3', '0', '0'], ['3', '3', '9', '2', '7', '9', '6', '8', '2', '0', '2', '8', '7', '0', '5', '6', '6', '0'], ['3', '7', '9', '9', '5', '8', '8', '0', '8', '3', '6', '3', '9', '2', '5', '7', '6', '0'], ['1', '2', '4', '9', '7', '0', '8', '2', '1', '7', '4', '8', '3', '9', '5', '7', '4', '0'], ['5', '3', '0', '0', '2', '3', '3', '5', '2', '8', '1', '3', '9', '8', '9', '3', '0', '0'], ['7', '7', '7', '7', '7', '0', '4', '5', '6', '2', '9', '6', '0', '9', '2', '4', '0', '0'], ['3', '5', '4', '0', '2', '5', '2', '0', '7', '0', '4', '3', '6', '7', '6', '3', '5', '0'], ['6', '3', '1', '0', '3', '4', '1', '6', '7', '0', '0', '1', '2', '5', '3', '9', '0', '0'], ['7', '3', '0', '9', '1', '5', '4', '7', '7', '0', '3', '8', '7', '3', '9', '8', '0', '0'], ['6', '0', '2', '1', '5', '2', '7', '1', '3', '7', '8', '5', '2', '2', '8', '2', '0', '0'], ['5', '3', '1', '6', '3', '9', '0', '8', '1', '1', '2', '9', '9', '6', '5', '0', '0', '0'], ['2', '4', '9', '1', '2', '8', '2', '1', '5', '8', '8', '8', '8', '4', '1', '5', '4', '0']]

function getResult (random) {
  switch (random) {
    case '660461428994091800':
      return 'A'

    case '566030890719055040':
      return 'B'

    case '267429262386612000':
      return 'C'

    case '501966835910029300':
      return 'D'

    case '77474370483870110':
      return 'E'

    case '521696713268012600':
      return 'F'

    case '533615350843106100':
      return 'G'

    case '698919002721323800':
      return 'H'

    case '678166340077078800':
      return 'I'

    case '198032394924609500':
      return 'J'

    case '389033236268441660':
      return 'K'

    case '592818869693146000':
      return 'L'

    case '494884428976535700':
      return 'M'

    case '194151761493556400':
      return 'N'

    case '764806667376171800':
      return 'O'

    case '261871399345627360':
      return 'P'

    case '499912047629738300':
      return 'Q'

    case '543707352438697150':
      return 'R'

    case '590671301963189500':
      return 'S'

    case '687444290936755200':
      return 'T'

    case '280332102953048900':
      return 'U'

    case '361686886764076350':
      return 'V'

    case '450006815445454200':
      return 'W'

    case '22144759689796708':
      return 'X'

    case '352766623092228200':
      return 'Y'

    case '409732507720113860':
      return 'Z'

    case '79131017656766930':
    case '530023352813989300':
      return 'a'

    case '793390991864630400':
    case '175759715584209380':
    case '417350281448593300':
    case '298786371272483100':
    case '671366334433649500':
    case '631034167001253900':
      return 'b'

    case '561455555387164200':
      return 'c'

    case '245196280119681730':
      return 'd'

    case '622460224812556700':
    case '108023502935532060':
    case '589768194614712300':
      return 'e'

    case '572162400722696500':
      return 'f'

    case '255309569281703580':
      return 'g'

    case '6423646997055009':
      return 'h'

    case '135324551848649310':
      return 'i'

    case '244612457674411780':
      return 'j'

    case '543021526951619300':
      return 'k'

    case '682157227665132900':
      return 'l'

    case '439137423647191550':
      return 'm'

    case '733937464262959900':
      return 'n'

    case '215921037876964320':
      return 'o'

    case '783088237497191600':
      return 'p'

    case '813949953920724900':
      return 'q'

    case '39100643078813944':
      return 'r'

    case '198270485052828540':
      return 's'

    case '388751963101577150':
      return 't'

    case '675958165739783800':
      return 'u'

    case '302624322158135940':
      return 'v'

    case '547635281146759100':
      return 'w'

    case '399570241699244540':
      return 'x'

    case '829871853681635200':
      return 'y'

    case '165444722468463500':
      return 'z'

    case '567579277949340200':
    case '339279682028705660':
      return '0'

    case '45680360715898080':
    case '379958808363925760':
      return '1'

    case '414818487752799100':
    case '314450876995722100':
    case '829902465568509600':
    case '124970821748395740':
      return '2'

    case '403070277702895800':
    case '629700218059825500':
    case '772132902068381000':
      return '3'

    case '525218453108393700':
    case '602152713785228200':
      return '4'

    case '531639081129965000':
      return '5'

    case '730915477038739800':
    case '249128215888841540':
      return '6'

    case '245373732967331500':
    case '354025207043676350':
      return '7'

    case '777770456296092400':
      return '8'

    case '79315429450426260':
      return '9'
  }
}

function main () {
  let result = ''

  for (let i = 0, randomJoin; i < randomResult.length; i++) {
    randomJoin = randomResult[i].join('')

    result += getResult(randomJoin)
  }

  return result
}

export default main
